// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import MetaInfo from 'vue-meta-info'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/reset.css'
import './common/editor/editor.js'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(MetaInfo)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: {App},
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js